// @ts-nocheck
import { SimpleQuoteFormFieldValues } from "@store/Framework/Store/Greif/Components/SimpleQuoteForm/SimpleQuoteFormState";
import { createHandlerChainRunnerOptionalParameter, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type Parameter = Array<keyof SimpleQuoteFormFieldValues>;
type HandlerType = Handler<Parameter>;

export const DispatchCancelDraftFieldValues: HandlerType = props => {
    props.dispatch({
        type: "Greif/Components/SimpleQuoteForm/CancelDraftFieldValues",
        keys: props.parameter,
    });
};

export const chain = [DispatchCancelDraftFieldValues];

const cancelDraftFieldValues = createHandlerChainRunnerOptionalParameter(
    chain,
    [] as Parameter,
    "CancelDraftFieldValues",
);

export default cancelDraftFieldValues;
